import script from "./ExchangeRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./ExchangeRecord.vue?vue&type=script&setup=true&lang=js"

import "./ExchangeRecord.vue?vue&type=style&index=0&id=6722115d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6722115d"]])

export default __exports__